import React from 'react'
import CloseReasonManagementPage from '../../reasons/routes/CloseReasonManagementPage.jsx'
import AdminFunction from './AdminFunctionPage'
import OfferConfigs from './OfferConfigs'
import SystemConfigPage from './SystemConfigPage'
import TestingConfig from './TestingConfig'
import UserManualPage from './UserManualPage'
import AnnouncementPage from '@/features/announcements/routes/AdminAnnouncementPage/AnnouncementPage.jsx'
import AdminEmailFunctionPage from './AdminEmailFunctionPage/AdminEmailFunctionPage.jsx'

const configRoutes = [
  {
    breadcrumb: 'Offer Configs',
    path: 'offer',
    element: <OfferConfigs />,
    children: [],
  },
  {
    breadcrumb: 'User Manual',
    path: 'userManual',
    element: <UserManualPage />,
    children: [],
  },
  {
    breadcrumb: 'Testing Configs',
    path: 'testing',
    element: <TestingConfig />,
    children: [],
  },
  {
    breadcrumb: 'Admin Function',
    path: 'adminFunction',
    element: <AdminFunction />,
    children: [],
  },
  {
    breadcrumb: 'Admin Email Function',
    path: 'adminEmailFunction',
    element: <AdminEmailFunctionPage />,
    children: [],
  },
  {
    breadcrumb: 'Close Reason Management ',
    path: 'closeReasons',
    element: <CloseReasonManagementPage />,
    children: [],
  },
  {
    breadcrumb: 'Announcement',
    path: 'announcement',
    element: <AnnouncementPage />,
    children: [],
  },
  {
    breadcrumb: 'System Config',
    path: 'systemConfig',
    element: <SystemConfigPage />,
    children: [],
  },
]

export default configRoutes
